/**
 * Primitive Color Tokens
 *
 * Raw color palette values - the foundation of the color system.
 * Source of truth from Figma Design System.
 *
 * @see DS-001-colors.md
 * @figma https://www.figma.com/design/NXGWL5ErhbsA0kqoybqQbg/Design-System?node-id=37-5385
 */

export const primitiveColors = {
  grey: {
    white: "#ffffff",
    10: "#fafafa",
    50: "#f5f7fb",
    100: "#f1f4f9",
    200: "#e2e8f0",
    300: "#cbd5e0",
    400: "#a9b9cc",
    500: "#8496ae",
    600: "#68778d",
    700: "#4a5568",
    800: "#323a43",
    900: "#202327",
    950: "#111214",
  },
  smalt: {
    50: "#eef7ff",
    100: "#d9edff",
    200: "#bbe0ff",
    300: "#8dceff",
    400: "#57b1ff",
    500: "#308fff",
    600: "#1970f7",
    700: "#1155d9",
    800: "#1548b8",
    900: "#003499",
    950: "#132858",
  },
  red: {
    50: "#fff1f1",
    100: "#ffe1e1",
    200: "#ffc7c7",
    300: "#ffa0a0",
    400: "#ff7878",
    500: "#f83b3b",
    600: "#e51d1d",
    700: "#c11414",
    800: "#a01414",
    900: "#841818",
    950: "#480707",
  },
  blue: {
    50: "#eff5ff",
    100: "#dbe8fe",
    200: "#c0d8fd",
    300: "#94c1fc",
    400: "#629ff8",
    500: "#3273f3",
    600: "#275ce9",
    700: "#1f47d6",
    800: "#203bad",
    900: "#1f3689",
    950: "#182253",
  },
  green: {
    50: "#effaf4",
    100: "#d8f3e2",
    200: "#b4e6c9",
    300: "#83d2aa",
    400: "#44a878",
    500: "#2d9c6a",
    600: "#1e7d55",
    700: "#186445",
    800: "#155038",
    900: "#12422f",
    950: "#09251b",
  },
  yellow: {
    50: "#fff9ed",
    100: "#fff1d4",
    200: "#ffdfa8",
    300: "#ffc671",
    400: "#ffaf52",
    500: "#fe8711",
    600: "#ef6b07",
    700: "#c65008",
    800: "#9d3f0f",
    900: "#7e3610",
    950: "#441806",
  },
} as const;

/**
 * CTA Orange colors - Unique brand accent for primary actions.
 * Separate scale as they don't follow the standard primitive pattern.
 */
export const ctaOrangeColors = {
  50: "#fff4ed",
  100: "#ffe6d4",
  200: "#ffcaa8",
  300: "#ffa471",
  400: "#ff7b43",
  500: "#ff5a1f",
  600: "#f03d06",
  700: "#c72c07",
  800: "#9d1d0f",
  900: "#7e1a12",
} as const;

/**
 * Purple gradient colors - Special accent for unique use cases.
 */
export const purpleGradientColors = {
  start: "#ff51ed",
  end: "#b400c4",
} as const;
